import React, { useEffect, useState } from 'react';
import '../styles/panelDePuntuaciones.css';

//Imagenes
import fichoAzul from '../imgs/fichos/Ficho-azul.png';
import fichoRojo from '../imgs/fichos/Ficho-rojo.png';
import fichoVerde from '../imgs/fichos/Ficho-verde.png';
import fichoRosa from '../imgs/fichos/Ficho-amarillo.png';
import gusano from '../imgs/otros/gusano.png';

//Librerias
import { estilos2 } from '../Lib/estilosCuentaRegresiva';

//Array de reemplazo del original cuando acaba la partida.
const puntuaciones = [
  {
      "ficho": "azul",
      "puntuacion": 0,
      "img": fichoAzul,
      "preguntas": 0

  },
  {
      "ficho": "rojo",
      "puntuacion": 0,
      "img": fichoRojo,
      "preguntas": 0
  },
  {
      "ficho": "verde",
      "puntuacion": 0,
      "img": fichoVerde,
      "preguntas": 0
  },
  {
      "ficho": "rosa",
      "puntuacion": 0,
      "img": fichoRosa,
      "preguntas": 0
  },
]

export default function PanelDePuntuaciones(props) {
  const [ estilosBorde, setEstilosBorde ] = useState("0.5vw solid rgb(0, 50, 126)");

  //Fragmento de codigo para solucionar el error que cuando termina el juego por tiempo el array se vacia y saca un error por que no tiene de donde agarrar la informacion entonces se usa el array correspondiente situado en esta parte del codigo.
  let puntuacionesArray;
  if(props.puntuaciones.length === 0){
    puntuacionesArray = puntuaciones;
  }else{
    puntuacionesArray = props.puntuaciones;
  }

  useEffect(() => {
    let randomValue2 = Math.floor((Math.random() * 30) + 1);
    setEstilosBorde(estilos2[randomValue2]);
  }, [puntuacionesArray[0].puntuacion, puntuacionesArray[1].puntuacion, puntuacionesArray[2].puntuacion, puntuacionesArray[3].puntuacion])

  return (
    <div className='panelPuntuaciones__div--container'>
      <img className='panelPuntuaciones__img--gusano-adorno' src={gusano} alt='gusano.png'/>
      <div className='panelPuntuaciones__div--borde' style={{"border": `0.3vw solid ${estilosBorde}`}} >
        <h3 className='panelPuntuaciones__h3'>Puntos</h3>
        <div className='panelPuntuaciones__div--container-puntos-imagen'>
          <img className='panelPuntuaciones__img panelPuntuaciones__img--ficho-azul' draggable="false" src={fichoAzul} alt='ficho-azul.png'/>
          <p>{puntuacionesArray[0].puntuacion}</p>
        </div>
        <div className='panelPuntuaciones__div--container-puntos-imagen'>
          <img className='panelPuntuaciones__img panelPuntuaciones__img--ficho-rojo' draggable="false" src={fichoRojo} alt='ficho-rojo.png'/>
          <p>{puntuacionesArray[1].puntuacion}</p>
        </div>
        <div className='panelPuntuaciones__div--container-puntos-imagen'>
          <img className='panelPuntuaciones__img panelPuntuaciones__img--ficho-verde' draggable="false" src={fichoVerde} alt='ficho-verde.png'/>
          <p>{puntuacionesArray[2].puntuacion}</p>
        </div>
        <div className='panelPuntuaciones__div--container-puntos-imagen'>
          <img className='panelPuntuaciones__img panelPuntuaciones__img--ficho-rosa' draggable="false" src={fichoRosa} alt='ficho-rosa.png'/>
          <p>{puntuacionesArray[3].puntuacion}</p>
        </div>
      </div>
    </div>
  )
}
